/**
 * k-add_cart.js
 * Handles AJAX cart updates and re-rendering for the k-add Cart sections.
 */

let kCartUpdateTimer = null;

function kCartChangeQty(lineKey, delta) {
  const itemRow = document.querySelector(`.k-cart-item[data-key="${lineKey}"]`);
  if (!itemRow) return;
  const input = itemRow.querySelector('.k-qty-input');
  if (!input) return;

  let currentVal = parseInt(input.value) || 0;
  let newVal = currentVal + delta;
  if (newVal < 0) newVal = 0;
  input.value = newVal;

  clearTimeout(kCartUpdateTimer);
  kCartUpdateTimer = setTimeout(() => {
    kCartUpdate(lineKey, newVal);
  }, 500);
}

function kCartInputQty(lineKey, newVal) {
  clearTimeout(kCartUpdateTimer);
  kCartUpdateTimer = setTimeout(() => {
    kCartUpdate(lineKey, parseInt(newVal) || 0);
  }, 500);
}

function kCartUpdate(lineKey, quantity) {
  const itemRow = document.querySelector(`.k-cart-item[data-key="${lineKey}"]`);
  
  if (itemRow) {
    const loaderText = itemRow.querySelector('.k-loader-text');
    if (quantity === 0) {
      itemRow.classList.add('removing');
      if (loaderText) loaderText.textContent = "カートから削除中";
    } else {
      itemRow.classList.add('is-loading');
      if (loaderText) loaderText.textContent = "カートを更新中";
    }
  }
  
  const body = JSON.stringify({
    id: lineKey,
    quantity: quantity
  });

  fetch(`${routes.cart_change_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: body
  })
  .then(response => response.json())
  .then(state => {
    // Re-render HTML parts using section rendering API
    const sectionsToRender = ['main-cart-items', 'main-cart-footer'];
    const sectionIds = sectionsToRender.map(id => document.getElementById(id)?.dataset.id).filter(Boolean);
    
    if(sectionIds.length > 0) {
      fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
      .then(res => res.json())
      .then(sectionsHtml => {
        if (itemRow) {
          const spinner = itemRow.querySelector('.k-spinner');
          const checkIcon = itemRow.querySelector('.k-check-icon');
          const loaderText = itemRow.querySelector('.k-loader-text');
          
          if (spinner) spinner.style.setProperty('display', 'none', 'important');
          if (checkIcon) checkIcon.style.display = 'block';
          if (loaderText) {
            loaderText.textContent = quantity === 0 ? "カートから削除しました" : "カートを更新しました";
          }
        }
        
        setTimeout(() => {
          sectionIds.forEach(id => {
            const el = document.querySelector(`[data-id="${id}"]`);
            if (el && sectionsHtml[id]) {
              const div = document.createElement('div');
              div.innerHTML = sectionsHtml[id];
              const newContent = div.querySelector(`[data-id="${id}"]`);
              if (newContent) {
                el.innerHTML = newContent.innerHTML;
              }
            }
          });
          
          window.dispatchEvent(new Event('cart:updated'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }, 600);
      });
    } else {
      window.location.reload();
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    if(itemRow) itemRow.classList.remove('is-loading');
  });
}

let kStickyObserver = null;

function initStickyFooter() {
  const mainFooter = document.querySelector('.k-cart-summary');
  const stickyFooter = document.getElementById('k-cart-sticky-footer');
  
  if (kStickyObserver) {
    kStickyObserver.disconnect();
  }
  
  if (mainFooter && stickyFooter) {
    kStickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const mainPlaceholder = document.getElementById('k-main-app-placeholder');
        const stickyPlaceholder = document.getElementById('k-sticky-app-placeholder');
        const appBlock = document.querySelector('.k-main-app-block');
        
        if (entry.isIntersecting) {
          stickyFooter.classList.add('is-hidden');
          // 画面内に本物のフッターが見えたら、アプリブロックを元に戻す
          if (appBlock && mainPlaceholder && mainPlaceholder !== appBlock.parentNode) {
            mainPlaceholder.appendChild(appBlock);
          }
        } else {
          stickyFooter.classList.remove('is-hidden');
          // 画面外に本物のフッターがいったら、アプリブロックを追従バーに移動する
          if (appBlock && stickyPlaceholder && stickyPlaceholder !== appBlock.parentNode) {
            stickyPlaceholder.appendChild(appBlock);
          }
        }
      });
    }, { root: null, threshold: 0 });
    
    kStickyObserver.observe(mainFooter);

    const toggleBtn = document.getElementById('k-sticky-toggle');
    const accordion = document.getElementById('k-sticky-accordion');
    const icon = document.getElementById('k-sticky-icon');
    
    if (toggleBtn && accordion && icon) {
      toggleBtn.addEventListener('click', () => {
        if (accordion.style.display === 'none') {
          accordion.style.display = 'block';
          icon.style.transform = 'rotate(180deg)';
        } else {
          accordion.style.display = 'none';
          icon.style.transform = 'rotate(0deg)';
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', initStickyFooter);
window.addEventListener('cart:updated', initStickyFooter);
